import styles from "./styles.module.css";

type Props = {
  comecoFimLista?: number[];
  setComecoFim?: Function;
  length?: number;
  listTitle: string[];
  styleList?: number[];
  children: any;
};

const Table = ({
  comecoFimLista,
  setComecoFim,
  length,
  listTitle,
  styleList,
  children,
}: Props) => {
  let lista = [];
  if (length) {
    for (let index = 0; index < length; index++) {
      lista.push(index);
    }
  }
  const selectStyle = (id: number) => {
    switch (styleList ? styleList[id] : 0) {
      case 1:
        return styles.thcenter;

      default:
        return "";
    }
  };

  return (
    <>
      <table className={styles.tabela}>
        <tbody>
          <tr className={styles.header}>
            {listTitle.map((colTitle: string, index) => (
              <th key={index} className={selectStyle(index)}>
                {colTitle}
              </th>
            ))}
          </tr>

          {children}
        </tbody>
      </table>

      {setComecoFim && comecoFimLista && (
        <div className={styles.btnRow}>
          {comecoFimLista[0] != 0 && (
            <button
              onClick={() =>
                setComecoFim([comecoFimLista[0] - 4, comecoFimLista[1] - 4])
              }
            >
              ❮
            </button>
          )}

          {lista.slice(0, Math.ceil(lista.length / 4)).map((_, index) => (
            <button
              className={
                index + 1 === comecoFimLista[1] / 4 ? styles.activeBtn : ""
              }
              key={index}
              onClick={() => setComecoFim([index * 4, (index + 1) * 4])}
            >
              {index + 1}
            </button>
          ))}

          {setComecoFim &&
            comecoFimLista[1] !== Math.ceil(lista.length / 4) * 4 && (
              <button
                onClick={() => {
                  setComecoFim([comecoFimLista[0] + 4, comecoFimLista[1] + 4]);
                }}
              >
                ❯
              </button>
            )}
        </div>
      )}
    </>
  );
};
export default Table;
